import axios from "axios"; // Axio HTTP Request
import moment from 'moment'; // MomentJS
import HTTPRequest from './controllers/httpRequest.js'; // HTTP Request
import secureStorage from './controllers/secureStorage.js'; // Cache Storage
import store from './store/store'; //vuex
import { isValidNumericFilterValue, findInvalidNumericFilters } from './utils/numericFilterValidation.js';

const setEnabledCategories = async() => {
    const loggedIn = secureStorage.getItem("loggedIn");
    const developerMode = secureStorage.getItem("developerMode");
    const isRippleAdmin = secureStorage.getItem("isRippleAdmin")

    if (!loggedIn || isRippleAdmin || developerMode) { return; }

    const categories = await HTTPRequest.getRequest(`${store.state.endPoint}system_module_categories/user_enabled_parent_categories`, null);

    const enabledCategories = categories.categories
    const enabledUrls = [];

    let parentCategories = []
    let addedParentCategories = []
    enabledCategories.map(category => {
        if (!addedParentCategories.includes(category.system_module_category_id)) {
            parentCategories.push({
                id: category.system_module_category_id,
                code: category.system_module_category_code,
                name: category.system_module_category_name,
            })
            addedParentCategories.push(category.system_module_category_id);
        }

        if (!enabledCategories.includes(category.endpoint)) {
            enabledUrls.push(category.endpoint)
        }
    })

    parentCategories.map((category, indx) => {
        const raw_children = enabledCategories.filter(module => module.system_module_category_id == category.id)
        parentCategories[indx].raw_children = raw_children;
    })

    store.commit('updateEnabledCategories', parentCategories)
    store.commit('updateEnabledCategoryUrls', enabledUrls)
}

const isPathPermitted = (path) => {
    // console.log(path);
    // return true;
    const loggedIn = secureStorage.getItem("loggedIn");
    const developerMode = secureStorage.getItem("developerMode");
    const isRippleAdmin = secureStorage.getItem("isRippleAdmin")

    // secureStorage.getItem("isAccountOwner"),

    if (!loggedIn || isRippleAdmin || developerMode) { return true; }

    const validPaths = [...store.state.enabledCategoryUrls, '/dashboard', '/jobs','/landing_page']
        // console.log(validPaths);

    if (validPaths.includes(path)) {
        // Checker for all enabled categories for current user
        return true;
    } else if (path.includes('/document_form')) {
        // Check if path is /document_form and if user has a /documents or /products_v2 permission
        const specialPaths = validPaths.filter(url => url.includes('/documents') || url.includes('/products_v2'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/children_products')) {
        // Check if path is /children_products and if user has a /documents permission
        const specialPaths = validPaths.filter(url => url.includes('/documents'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/advanced_promotions')) {
        // Check if path is /advanced_promotions and if user has a /promotions_dashboard permission
        const specialPaths = validPaths.filter(url => url.includes('/promotions_dashboard'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/product_updates') || path.includes('/products_v2')) {
        // Check if path is /product_updates and if user has a /products_v2 permission
        const specialPaths = validPaths.filter(url => url.includes('/products_v2'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/pos_document_form')) {
        // Check if path is /pos_document_form and if user has a /pos_documents permission
        const specialPaths = validPaths.filter(url => url.includes('/pos_documents'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/online_stores')) {
        // Check if path is /online_stores and if user has a /online_stores permission
        const specialPaths = validPaths.filter(url => url.includes('/online_stores'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/pos_session_details')) {
        // Check if path is /pos_session_details and if user has a /pos_session_details permission
        const specialPaths = validPaths.filter(url => url.includes('/pos_session_details') || url.includes('/tools'))
        if (specialPaths.length > 0) { return true; }
    } else if (path.includes('/eod_monitoring_dashboard')) {
        // Allow the dedicated EOD dashboard route during and after the move from /tools
        const specialPaths = validPaths.filter(url => url.includes('/eod_monitoring_dashboard') || url.includes('/tools'))
        if (specialPaths.length > 0) { return true; }
    }

    return false;
}

const sortAlphabetical = (arr, key) => {
  let feedback = arr.sort((a, b) => {
    const textA = a[key].toUpperCase();
    const textB = b[key].toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  });

  return feedback;
}

const compareData = (from, to) => {
    var diff = function (obj1, obj2) {

        // Make sure an object to compare is provided
        if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
            return obj1;
        }

        // Variables

        var diffs = {};
        var key;

        // Methods

        /**
        * Check if two arrays are equal
        * @param  {Array}   arr1 The first array
        * @param  {Array}   arr2 The second array
        * @return {Boolean}      If true, both arrays are equal
        */
        var arraysMatch = function (arr1, arr2) {

            // Check if the arrays are the same length
            if (arr1.length !== arr2.length) return false;

            // Check if all items exist and are in the same order
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i.substring(1)]) return false;
            }

            // Otherwise, return true
            return true;

        };

        /**
        * Compare two items and push non-matches to object
        * @param  {*}      item1 The first item
        * @param  {*}      item2 The second item
        * @param  {String} key   The key in our object
        */
        var compare = function (item1, item2, key) {

            // Get the object type
            var type1 = Object.prototype.toString.call(item1);
            var type2 = Object.prototype.toString.call(item2);

            // If type2 is undefined it has been removed
            if (type2 === '[object Undefined]') {
                diffs[key] = null;
                return;
            }

            // If items are different types
            if (type1 !== type2) {
                diffs[key] = item2;
                return;
            }

            // If an object, compare recursively
            if (type1 === '[object Object]') {
                var objDiff = diff(item1, item2);
                if (Object.keys(objDiff).length > 0) {
                    diffs[key] = objDiff;
                }
                return;
            }

            // If an array, compare
            if (type1 === '[object Array]') {
                if (!arraysMatch(item1, item2)) {
                    diffs[key] = item2;
                }
                return;
            }

            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (type1 === '[object Function]') {
                if (item1.toString() !== item2.toString()) {
                    diffs[key] = item2;
                }
            } else {
                if (item1 !== item2 ) {
                    diffs[key] = item2;
                }
            }

        };


        //
        // Compare our objects
        //

        // Loop through the first object
        for (key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                compare(obj1[key], obj2[key.substring(1)], key);
            }
        }

        // Loop through the second object and find missing items
        for (key in obj2) {
            if (obj2.hasOwnProperty(key)) {
                if (!obj1[key] && obj1[key] !== obj2[key.substring(1)] ) {
                    diffs[key] = obj2[key.substring(1)];
                }
            }
        }

        // Return the object of differences
        return diffs;

    };

    return diff(from, to);
}

const uploadToS3 = async function(file, profile) {
  const accountName = secureStorage.getItem("accountName");
  const uploaderEndpoint = await HTTPRequest.getRequest(`${store.state.endPoint}settings/api_s3_uploader`, null, null) || {}
  if(profile=='time_keep_login'){
    uploaderEndpoint = await HTTPRequest.getRequest(`${store.state.endPoint}time_entries/api_s3_uploader`, null, null) || {}
  }

  if (!uploaderEndpoint.endpoint) { return { error: 'No S3 endpoint' } }

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let fileResponse;
  await axios({
    method: 'POST',
    url: `${uploaderEndpoint.endpoint}?profile=${profile}&account_name=${accountName}`,
    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
    // Uncomment for Testing. Note: get user token in Staging
    // headers: {'Authorization': 'Bearer ' + 'd8A4aLal3OxA3RCKyUpHbX0LzJ6cbZfKtFqFXjicRsQ'},
    data : fileFormData
  })
  .then(function (response) {
    fileResponse = response.data
  })
  .catch(function (error) {
    fileResponse = { error: error }
    //console.log(error)
  });

  return fileResponse;
}

const uploadToS3BackgroundProcess = async function(file, profile) {
  
  const accountName = secureStorage.getItem("accountName");
  const uploaderEndpoint = await HTTPRequest.getRequest(`${store.state.endPoint}settings/api_s3_uploader_importer`, null, null) || {}
  
  console.log("uploaderEndpoint", uploaderEndpoint)

  if (!uploaderEndpoint.endpoint) { return { error: 'No S3 endpoint' } }

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let fileResponse;
  await axios({
    method: 'POST',
    url: `${uploaderEndpoint.endpoint}?profile=${profile}&account_name=${accountName}`,
    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
    // Uncomment for Testing. Note: get user token in Staging
    // headers: {'Authorization': 'Bearer ' + 'd8A4aLal3OxA3RCKyUpHbX0LzJ6cbZfKtFqFXjicRsQ'},
    data : fileFormData
  })
  .then(function (response) {
    fileResponse = response.data
  })
  .catch(function (error) {
    fileResponse = { error: error }
    //console.log(error)
  });

  return fileResponse;
}

// Upload a file directly to S3 using a backend-issued presigned PUT URL.
// This bypasses the API Gateway 10MB payload limit that uploadToS3 hits, so it
// is used for large files like POS update zips. Returns { path } on success
// (the permanent S3 object URL) or { error } on failure.
const uploadToS3Presigned = async function(file, profile) {
  const accountName = secureStorage.getItem("accountName");
  const contentType = file.type || 'application/octet-stream';

  const presign = await HTTPRequest.getRequest(
    `${store.state.endPoint}pos_releases/get_upload_url` +
      `?profile=${encodeURIComponent(profile)}` +
      `&account_name=${encodeURIComponent(accountName || '')}` +
      `&filename=${encodeURIComponent(file.name)}` +
      `&content_type=${encodeURIComponent(contentType)}`,
    null, null
  );

  if (!presign || presign.error || !presign.success || !presign.success.url) {
    return { error: { code: 'PRESIGN_FAILED', message: (presign && presign.error) || 'Could not get upload URL' } };
  }

  try {
    // PUT straight to S3. Content-Type MUST match what was signed on the
    // backend, otherwise S3 rejects the signature.
    await axios.put(presign.success.url, file, {
      headers: { 'Content-Type': contentType }
    });
    return { path: presign.success.path };
  } catch (error) {
    return { error: { code: 'S3_PUT_FAILED', message: error.message } };
  }
}

const objectToFormData = (form, obj, parentKey=null, isParentArray=false) => {
  for (const [key, value] of Object.entries(obj)) {
    if ([null, undefined].includes(value)) { continue; }
    if (typeof value === 'object' && !Array.isArray(value)) {
      // Object
      let newKey = parentKey ? `${parentKey}[${key}]` : key;
      newKey = isParentArray ? `${parentKey}[]` : newKey;
      if (value instanceof moment) {
        form.append(newKey, value.toDate());
      } else {
        objectToFormData(form, value, newKey);
      }
    } else if (typeof value === 'object' && Array.isArray(value)) {
      // Array
      let newKey = parentKey ? `${parentKey}[${key}]` : key;
      newKey = isParentArray ? `${parentKey}[]` : newKey;
      if (value instanceof moment) {
        form.append(newKey, value.toDate());
      } else {
        objectToFormData(form, value, newKey, true);
      }
    } else if (parentKey) {
      // Other with parentKey
      const newKey = isParentArray ? `${parentKey}[]` : `${parentKey}[${key}]`;
      form.append(newKey, value);
    } else {
      // Other
      form.append(key, value);
    }
  }
}

const formatStatus = (value) => {
    switch (value) {
      case 'A':
        return 'Active'
      case 'I':
        return 'Inactive'
      case 'D':
        return 'Disabled'
      case 'C':
        return 'Created'
      case 'S':
        return 'Sold'
      case 'U':
        return 'Used'
      case 'V':
        return 'Voided'
      default:
        return value
    }
  }

const compareJsonObject = (from, to, currentObj) => {
    var arrayUnique = function(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
  }
    var diff = function (obj1, obj2) {
      const obj = currentObj || []
      const result = {};
      if (Object.is(obj1, obj2)) {
          return undefined;
      }
      if (!obj2 || typeof obj2 !== 'object') {
          return obj2;
      }
      arrayUnique(Object.keys(obj1 || {}).concat(Object.keys(obj2 || {}))).forEach(key => {
          if(obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
              result[key] = obj2[key];
              var index = obj.findIndex(n => n.key == key)
              if (index > -1){
                  if(obj[index]['old_value'] == obj2[key]){
                    obj.splice(index,1)
                  }else{
                    obj[index] = {key:key,old_value:obj1[key],new_value:obj2[key]}
                  }
              }else{
                obj.push({key:key,old_value:obj1[key],new_value:obj2[key]})
              }
          }
          if(typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
              const value = diff(obj1[key], obj2[key]);
              if (value !== undefined) {
                  result[key] = value;
              }
          }
      });
      return obj;
    }
    return diff(from, to);
}

let getReportDescription = (cProfile) => {
  switch(cProfile){
    // basic sales reports
    case 'pos_sales_journals':
      return 'This report is used to provide the detailed POS Sales that can be grouped by Terminal, and Cashier. It can be filtered by the Status and Select different sites in order to monitor each sales per site.'
    case 'item_returns_reports':
      return 'This report shows an analysis of item returns. It shows a list of frequently returned items per site within a given time period based on quantity and amount. An in-depth analysis of the data can help the business trace which items are most commonly remitted by consumers.'
    case 'item_sales_reports':
      return 'Report that shows a listing of items sales. Its purpose is to help show the item’s sales trends that occur based on consumer behavior in relation with a company’s sales volume over time.'
    case 'daily_sales_invoice_with_margins':
      return ''
    case 'daily_sales_invoices':
      return ''
    case 'margin_sales_reports':
      return ''
    case 'detailed_sold_out_reports':
      return ''
    case 'basic_inventory_reports':
      return ''
    case 'category_returns_reports':
      return 'This report shows an analysis of item returns grouped by category. It shows a list of frequently returned items per site within a given time period based on quantity and amount. An in-depth analysis of the data shown in this document can help the business trace which items from which categories are most commonly remitted by consumers.'
    case 'category_sales_reports':
      return 'Report that shows a report listing of sales by category. Its purpose is to help show the category’s sales trend that occurs based on consumer behavior in relation with a company’s sales volume over time'
    case 'detailed_discount_reports':
      return ''
    case 'discounted_items_report':
      return ''
    case 'general_inventory_report_advances':
      return 'Generates a report that shows the general or overall onhand stock or number of items left on stock.'
    case 'general_inventory_with_packing_breakdown_reports':
      return ''
    case 'inventory_aging_reports':
      return 'This report shows how new or old the inventories available for an item are. This report details the oldest receive date up to the current receive document for all items in the inventory. This report is usually used to evaluate value and identify items that have been setting in the inventory for too long and are in need of disposal, etc.'
    case 'inventory_aging_valuations':
      return 'Similar to that of the inventory aging report - the only difference is this report contains cost value.'
    case 'inventory_cost_layer_reports':
      return ''
    case 'item_sales_profits':
      return 'This shows how much was earned on the item sales by comparing sales amount vs cost amount of the item.'
    case 'sales_reports':
      return ''
    case 'oms_daily_sales_reports':
      return 'This shows how much was earned on the item sales by comparing sales amount vs cost amount of the item.'
    case 'hourly_sales_reports':
      return 'This is also very similar to the Item Sales Report. The difference here is that instead of looking at sales coming from our point-of-sales (POS) it looks for Sales Invoices coming from our Order Management Module (OMS) in the backend.'
    case 'matrix_sales_reports':
      return 'This is very similar to the regular item sales report. The difference in this report is that this only is particular to Matrix Items or items with variants (Size, Color, Style).'
    case 'stock_valuation_reports':
      return 'The stock activity valuation report generates the retail price of the product inventory and the movement of the item from the moment it was ordered to the time it was sold to the customer (inclusive of adjustments made). It provides the cost value of the perpetual product stock of a business. Value is measured according to the quantity on-hand and the cost of the products.'
    case 'stock_valuation_summaries':
      return 'Generates a list of the quantity of grouped items received during a specific time period. The purpose of this report is to identify slow moving inventory and the additional costs of storing and maintaining these products until they are sold.'
    case 'serial_tracking_reports':
      return 'This report displays the movements of inventory of a serial item.'
    case 'serial_item_reports':
      return 'This report is used to keep track or list down available units of serial items. Serial items are high-value items that we keep inventory of.'
    case 'physical_count_variance_reports':
      return 'This report is used to keep track or list down the physical count variance per report from the date selected.'
    case 'stock_valuation_report_with_costs':
      return 'This report is used to keep track or list down stock valuation reports with detailed cost.'
    case 'stock_valuation_summary_with_costs':
      return 'This report is used to keep track or list down available stock valuation summary with detailed cost.'
    case 'pos_activity_reports':
      return 'This report is used to provide the detailed POS Activity that can be grouped by Terminal, Cashier, and Session. It will provide a series of activity types in order to monitor each activity on a day to day analytics.'
    case 'assemble_journals':
      return 'This report is used to provide the detailed Assemble Status that can be filtered by the status such as posted, saved, and voided with providing the Assemble Order Status.'
    case 'disassemble_journals':
      return 'This report is the same as Assemble Journal but the difference is the one that is filtered is the Disassemble Status.'
    case 'consolidated_po_journals':
      return 'This report is used to provide the detailed Consolidated PO that can be filtered by the Status and Order Status such as posted, saved, voided, and etc.'
    case 'branch_inventory_journals':
      return 'This report is used to provide the detailed Inventory of each Branch that can be filtered by the Status and Order Status such as posted, saved, voided, and etc.'
    case 'quotation_journals':
      return 'This report is used to provide the detailed Quotation list that can be filtered by the Status and Order Status such as posted, saved, voided, and etc.'
    case 'price_work_sheet_journals':
      return 'This report is used to provide the detailed Price Work Sheet list that can be filtered by the Status and Order Status such as posted, saved, voided, and etc.'
    case 'concession_sales_journals':
      return 'This report is used to provide the detailed Concession Sales list that can be filtered by the Status and Order Status such as posted, saved, voided, and etc.'
    case 'concession_returns_journals':
      return 'This report is the same as Concession Sales Journal but the difference is the one that is filtered is the Concession Return Status.'
    case 'pos_reservations_journals':
      return 'This report is used to provide the detailed POS Sales that can be grouped by Terminal, and Cashier. It can be filtered by the Status and Select different sites in order to monitor each sales per site.'
    case 'pos_returns_journals':
      return 'This report is used to provide the detailed POS Return that can be grouped by Terminal, and Cashier. It can be filtered by the Status and Select different sites in order to monitor each sales per site.'
    case 'sublocation_transfer_out_journals':
      return 'This report is used to provide the detailed Sublocation Transfer Out that can be filtered by the status such as posted, saved, and voided with providing the Order Status of the Sublocation Transfer.'
    case 'sublocation_transfer_in_journals':
      return 'This report is the same as Sublocation Transfer In Journal but the difference is the one that is filtered is the Sublocation Transfer In Status.'
    case 'sales_order_journals':
      return 'This report is used to provide the detailed Sales Order that can be filtered by the status such as posted, saved, and voided with access to monitoring sales order of each site.'
    case 'sales_invoice_journals':
      return 'This report is the same as Sales Order Journal but the difference is the one that is filtered is the Sales Invoice  In Status.'
    case 'delivery_document_journals':
      return 'This report is used to provide the detailed Delivery Document that can be filtered by the status such as posted, saved, and voided with access to monitoring Delivery Document of each site and reference for the future needs.'
    case 'suppliers_bill_journals':
      return 'This report is used to provide the detailed Supplier Bill that can be filtered by the status such as posted, saved, and voided with access to monitoring Suppliers Bill for each site and reference for the future needs.'
    case 'concession_transfer_request_journals':
      return 'This report is used to provide the detailed Concession Transfer Request that can be filtered by the status such as posted, saved, and voided with access to monitoring Concession Transfer Request for each site and reference for the future needs.'
    case 'concession_transfer_order_journals':
      return 'This report is the same as Concession Transfer Order Journal but the difference is the one that is filtered is the Concession Transfer Order In Status.'    
    case 'concession_transfer_out_journals':
      return 'This report is the same as Concession Transfer Order Journal but the difference is the one that is filtered is the Concession Transfer Out Status.'
    case 'concession_transfer_in_journals':
      return 'This report is the same as Concession Transfer Order Journal but the difference is the one that is filtered is the Concession Transfer In Status.'
    case 'price_change_by_line_reports':
      return 'This report is used to provide the detailed Price Change By Line that can be filtered by the status of Selecting Site, Terminal, and Cashier.'
    case 'eod_by_cashier_and_pos':
      return 'This report is used to provide the detailed End of Day by both Cashier and POS that can be filtered by the status of Selecting Site, and Cashier. This is a good future reference incase of theft.'             
    case 'receiving_report_journals':
      return 'This report is used to keep track or list down available units of serial items. Serial items are high-value items that we keep inventory of.'
    case 'purchase_order_journals':
      return 'This report is used to provide the detailed Purchase Order that can be filtered by the status such as posted, saved, and voided with access to monitoring Purchase Order for each site and reference for the future needs.'    
    case 'purchase_request_journals':
      return 'This report is used to provide the detailed Purchase Request that can be filtered by the status such as posted, saved, and voided with access to monitoring Purchase Request for each site and reference for the future needs.'
    case 'purchase_return_journals':
      return 'This report is used to provide the detailed Purchase Return that can be filtered by the status such as posted, saved, and voided with access to monitoring Purchase Return for each site and reference for the future needs.'
    case 'advance_shipment_notice_journals':
      return 'This report is used to provide the detailed Advance Shipment Notice that can be filtered by the status such as posted, saved, and voided with access to monitoring Advance Shipment for each site and reference for the future needs.'
    case 'transfer_request_journals':
      return 'This report is used to keep track or list down detailed Transfer Requests by each warehouse to site for future references that can be filtered by Sites, Order Status, and etc. '
    case 'adjustment_in_journals':
      return 'This report is used to keep track or list down detailed Adjustments  In by each warehouse to site for future references that can be filtered by Sites, Order Status, and etc. '
    default: return ''
  }
}
// const dissectReportFilters = (parameters, displayOptions, formatOptions) => {
//   let parameterKeys = Object.keys(parameters)
//   let advanceFilters = parameters.advanced_filter
//   let productFilterKeys = Object.keys(advanceFilters)
//   let basicFilters = {}
//   let filterLabels = {}

//   parameterKeys.forEach((key) => {
//     let currentKey;
//     switch (key) {
//       case 'isFormat':
//         currentKey = parameters[key]
//         basicFilters['format'] = formatOptions.filter(({ key }) => key == currentKey)[0].value
//         break;

//       case 'group':
//         basicFilters['group_by'] = parameters[key].split("_")[0]
//         break;

//       case 'order':
//         basicFilters['sort_by'] = parameters[key].split("_")[0]
//         break;

//       case 'by':
//         basicFilters['sort_by'] = `${basicFilters['sort_by']}(${(_.upperCase(parameters[key]))})`
//         break;

//       case 'display':
//         currentKey = parameters[key]
//         basicFilters['display'] = displayOptions.filter(({ key }) => key == currentKey)[0].value
//         break;
//     }
//   })

//   let filterKeys = Object.keys(basicFilters)
//   let productFilters = productFilterKeys.filter((key) => ((advanceFilters[key] !== null) && (advanceFilters[key].length !== 0))).map((fKey) => {
//     if (fKey.includes('_id')) {
//       fKey = fKey.replace('_id', '')
//     }
//     fKey = _.capitalize(fKey.split('_').join(" "))
//     return fKey
//   })
//   filterLabels['basic'] = filterKeys.map((key) => `${_.capitalize(key.replace("_", " "))}: ${basicFilters[key]}`).join(", ")
//   filterLabels['advance'] = productFilters.join(", ")
//   return filterLabels
// }

/**
 * Reusable numeric validation for Advanced Filter values.
 *
 * Implemented in a dependency-free module (src/utils/numericFilterValidation.js)
 * so it can be unit-tested in isolation and reused across Advanced Filter
 * numeric inputs. Re-exported here for convenient access alongside the other
 * shared utilities.
 */

export {
  setEnabledCategories,
  isPathPermitted,
  sortAlphabetical,
  compareData,
  uploadToS3,
  uploadToS3BackgroundProcess,
  uploadToS3Presigned,
  objectToFormData,
  formatStatus,
  compareJsonObject,
  getReportDescription,
  isValidNumericFilterValue,
  findInvalidNumericFilters
};
